import React from 'react';
import './onboarding1.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Onboardingbasic from '../components/layout/onboarding';
import Preloader from '../components/common/preloader';

const Onboarding1 = () => {

    const [onboarding, setonboarding]= useState([]);
      useEffect(() => {
      const getonboarding = async()=>{
          const res = await supabase.from('onboardingscreen_mobile').select('*').order('id', { ascending: true });;;
    
      setonboarding(res.data);
      }
      getonboarding();
      }, []);


                  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />



    return ( 

        <main className='onboarding-screen-background'>
            <Onboardingbasic img={onboarding?.[0]?.img} title={onboarding?.[0]?.header} parag={onboarding?.[0]?.paragraph}
            nextPage="/onboarding-page2"
              currentPage={1}/>

        </main>

     );
}
 
export default Onboarding1
